const bind = () => {
    $('[data-ofc-submenu]')
        .off('click')
        .on('click', function () {
            const el = $(this);
            const sMenuId = el.data('ofcSubmenu');
            const menuItem = el.closest('.menu-item');
            const subMenu = el.closest('.menu-item').children(sMenuId);

            if(subMenu.length === 1) {
                el.parent().parent().parent().removeClass('overflow-auto')
                menuItem.addClass('ps-0');
                subMenu.addClass('show');
                subMenu.addClass('overflow-auto')
            }
        });

    $('.mobile-menu').on('show.bs.offcanvas', function () {
        $('html').css('overflow', 'hidden');
        $('.navbar-toggler i').addClass('fa-xmark').removeClass('fa-bars');
        $('#scrollTopBlock').css('display', 'none');
        $('.offcanvas-backdrop').on('click', function () {
            $('.mobile-menu').offcanvas('hide');
        });
    });

    $('.mobile-menu').on('hide.bs.offcanvas', function () {
        $('html').css('overflow', 'auto');
        $('.navbar-toggler i').addClass('fa-bars').removeClass('fa-xmark');
        $('#scrollTopBlock').css('display', 'block');
    });

    $(window).on('resize', function () {
        if ($(window).outerWidth() >= 1200) {
            $('.mobile-menu').offcanvas('hide');
        }
    });

    $('[data-ofc-menu-close]')
        .off('click')
        .on('click', function () {
            const el = $(this);
            const sMenuId = el.data('ofcMenuClose');
            const menuItem = el.closest('.menu-item');
            const subMenu = el.closest(sMenuId);
            if(subMenu.length === 1) {
                subMenu.removeClass('show');
                subMenu.removeClass('overflow-auto');
                menuItem.removeClass('ps-0');
                menuItem.parent().parent().addClass('overflow-auto')
            }
        });
};

const bindSwipeToClose = () => {
    let touchStartX = 0;
    let touchEndX = 0;
    const swipeThreshold = 50; // minimum distance for swipe to be detected

    $('.mobile-menu').on('touchstart', function (event) {
        touchStartX = event.touches[0].clientX;
    });

    $('.mobile-menu').on('touchmove', function (event) {
        touchEndX = event.touches[0].clientX;
    });

    $('.mobile-menu').on('touchend', function () {
        if (touchStartX - touchEndX > swipeThreshold) {
            $(this).offcanvas('hide');
        }
    });
};

const load = () => {
    setTimeout(function () {
        $.get('/ajax/menu', {'menu': 'mobile'}).done(function (res) {
            $('nav.mobile-menu').replaceWith(res.mobileMenu);
        }).fail(function () {}).always(function () {
            bind();
        });
    }, 2000);
}

export {
    bind,
    bindSwipeToClose,
    load
}
